import { render, staticRenderFns } from "./ButtonSetDescription.vue?vue&type=template&id=242a6a61&"
import script from "./ButtonSetDescription.vue?vue&type=script&lang=js&"
export * from "./ButtonSetDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports